import {Directive, HostBinding, HostListener, Input} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';

interface NavigationState {
  navigationId?: number;
}

@Directive({
  selector: '[appNavigateBack]'
})
export class NavigateBackDirective {
  @Input() public appNavigateBack: string;
  @HostBinding('attr.type') public type: string = 'button';

  constructor(
    private readonly location: Location,
    private readonly router: Router
  ) {
  }

  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    event.preventDefault();
    this.back();
  }

  private back(): void {
    if (this.hasInAppHistory()) {
      this.location.back();
      return;
    }

    let url: string | undefined;
    if (this.appNavigateBack) {
      url = this.appNavigateBack;
    } else {
      url = this.getDefaultFallbackUrl();
    }

    this.router.navigateByUrl(url)
      .catch((error: unknown): void => {
        console.error('Navigate back failed', error);
      });
  }

  private hasInAppHistory(): boolean {
    const state: unknown = this.location.getState();
    if (state === null || state === undefined) {
      return false;
    }
    if (typeof state !== 'object') {
      return false;
    }

    const navigationState: NavigationState = state as NavigationState;
    if (typeof navigationState.navigationId !== 'number') {
      return false;
    }

    return navigationState.navigationId > 1;
  }

  private getDefaultFallbackUrl(): string {
    const path: string = this.router.url.split('?')[0];
    const segments: string[] = path.split('/').filter((segment: string): boolean => {
      return segment.length > 0;
    });
    if (segments.length === 0) {
      return '/';
    }

    return '/' + segments[0];
  }
}
